import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * The one loading indicator for content that isn't there yet.
 *
 * - default: a page's content area (60% of the window tall).
 * - `fullScreen`: before the app itself has started.
 * - `inline`: inside a panel or dialog, e.g. a list that loads on its own.
 *
 * The message always reads "Loading <what>…". Buttons that wait use
 * BusyButton instead.
 */
const LoadingSpinner = ({ message = 'Loading…', fullScreen = false, inline = false }) => (
  <Box
    role="status"
    aria-live="polite"
    sx={{
      minHeight: fullScreen ? '100vh' : inline ? 0 : '60vh',
      py: inline ? 3 : 0,
      display: 'flex',
      flexDirection: inline ? 'row' : 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: inline ? 1.5 : 2,
      color: 'text.secondary',
    }}
  >
    <CircularProgress size={inline ? 20 : 36} thickness={4} />
    <Typography variant="body2">{message}</Typography>
  </Box>
);

export default LoadingSpinner;
